import styled from '@emotion/styled';

import { ReactComponent as Computer } from '@icons/pencil-paintings/computer.svg';
import { ReactComponent as Eye } from '@icons/pencil-paintings/eye.svg';
import { ReactComponent as HealthArmour } from '@icons/pencil-paintings/health-armour.svg';
import { ReactComponent as Stereotypes } from '@icons/pencil-paintings/stereotypes.svg';
import { ReactComponent as ZigZags } from '@icons/pencil-paintings/zig-zags.svg';

import { illustrationsBase } from '@styles/mixins/illustrations';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const StyledHealthArmour = styled(HealthArmour)`
  ${illustrationsBase}
  top: 35px;
  right: 235px;

  ${getMediaqueryStyled('xl')} {
    width: 250px;
    top: 70px;
    right: 210px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 145px;
    top: 85px;
    right: 125px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledZigZags = styled(ZigZags)`
  ${illustrationsBase}
  top: 155px;
  right: 250px;

  ${getMediaqueryStyled('xl')} {
    width: 100px;
    top: 140px;
    right: 225px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 60px;
    top: 130px;
    right: 135px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledEye = styled(Eye)`
  ${illustrationsBase}
  top: 320px;
  right: 570px;

  ${getMediaqueryStyled('xl')} {
    width: 220px;
    top: 215px;
    right: 400px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 127px;
    top: 190px;
    right: 270px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledStereotypes = styled(Stereotypes)`
  ${illustrationsBase}
  bottom: 250px;
  right: 435px;

  ${getMediaqueryStyled('xl')} {
    width: 255px;
    bottom: 195px;
    right: 360px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 145px;
    bottom: 115px;
    right: 215px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledComputer = styled(Computer)`
  ${illustrationsBase}
  bottom: 140px;
  right: calc(-1 * var(--side-field-size));

  ${getMediaqueryStyled('xl')} {
    width: 332px;
    bottom: 100px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 192px;
    bottom: 60px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;
